import * as Api from '@ViewModels';

const FINISHED_JOB_STATUSES: readonly string[] = [
	'Cancelled',
	'Canceled',
	'Complete',
	'Completed',
	'Error',
	'Failed',
	'PartialSuccess',
	'Success',
];

const RUNNING_JOB_STATUSES: readonly string[] = ['InProgress', 'Pending', 'Processing', 'Queued', 'Running', 'Started'];

export const isSystemJobFinished = (job: Api.ISystemJobBase | undefined) => {
	if (!job) {
		return false;
	}
	if (job.status && RUNNING_JOB_STATUSES.includes(job.status)) {
		return false;
	}
	return job.percentComplete === 100 || (!!job.status && FINISHED_JOB_STATUSES.includes(job.status));
};

export const getSystemJobProgressFingerprint = (job: (Api.ISystemJobBase & { metadata?: unknown }) | undefined) =>
	job ? JSON.stringify([job.status, job.percentComplete, job.dateLastUpdatedUtc, job.metadata]) : '';
